export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp_2240000-8d67da7cdc6ae72e09e8f1c6251fdb53.avif";